"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Armen Avagumyan. Created on 4/20/2019.
 */
var performance_model_1 = require("./performance.model");
var PerformanceMeasure = /** @class */ (function (_super) {
    __extends(PerformanceMeasure, _super);
    function PerformanceMeasure(actual, target, achievement, progress) {
        var _this = _super.call(this, achievement, progress) || this;
        _this.actual = actual;
        _this.target = target;
        return _this;
    }
    PerformanceMeasure.emptyInstance = function () {
        return new PerformanceMeasure(null, null, null, null);
    };
    return PerformanceMeasure;
}(performance_model_1.Performance));
exports.PerformanceMeasure = PerformanceMeasure;
//# sourceMappingURL=performance-measure.model.js.map